import { select } from 'redux-saga/effects'
import settingsUtil from '../services/util/SettingsUtil'
import { Settings } from '../services/util/Settings'

export const getAuth = state => state.auth
export const getAccountData = state => state.accountData

export function* setAccountDataLanguage(action) {
    var accountData = yield select(getAccountData)

    if (accountData?.employeeId) {
        settingsUtil.setSetting(accountData.employeeId, Settings.LANG, action.lang);
    }
}
